<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Liquidations"
    :submit="submit"
    :status="status"
    
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="spot_id"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.spot_id"
                    :items="spots" item-text="address" item-value="id"
                    label="Lugar"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="user_id"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.user_id"
                    label="Usuario"
                    :items="users" :item-text="(row)=>`${row.name || ''} ${row.last_name || ''}`" 
                    item-value="id"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="total"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.total"
                  label="Total"
                  prefix="$"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="comission_percentage"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.comission_percentage"
                  label="Porcentaje de comisión"
                  type="Number"
                  prefix="%"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="month"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.month"
                  label="Mes"
                  type="Number"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="year"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.year"
                  label="Año"
                  type="Number"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="cbu_alias"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.cbu_alias"
                  label="CBU alias"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
        status: state => state.Faqs.status,
        users: state => state.Users.list,
        spots: state => state.Spots.list,
      })
    },
    async created(){
      const self = this;
      let filters = {};

      await self.$store.dispatch('Users/getListAll',filters);
      await self.$store.dispatch('Spots/getListAll',filters);

    },
    data() {
      return {
        storeName: 'Liquidations',
        title: "Liquidation",
        data: {
          spot_id: '',
          user_id: '',
          total: '',
          month:'',
          year:'',
          comission_percentage:'',
          cbu_alias:'',
        }
      }
    }
  }
</script>
